import { Box } from '@chakra-ui/react';
import { MouseEvent } from 'react';
import { ICalendarEvent } from '../../TCalendar';
import { IDayWithEvents } from '../../tcalendar.service';
import CalendarEvent from './components/calendar-event/calendar-event.view';
import DateInfo from './components/date-info.view';

interface IProps {
	/**
	 * True when the user is dragging the mouse to select a range of days.
	 */
	isDragging: boolean;
	timeZone: string;
	locale: string;
	day: IDayWithEvents;
	onMouseEnter?: (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
	onMouseDown?: (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
	onMouseUp?: (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void;
	onEventClick: (event: ICalendarEvent) => void | undefined;
}

export default function CalendarDay(props: IProps) {
	return (
		<Box
			data-timetime-element="day"
			onMouseDown={props.onMouseDown}
			onMouseEnter={props.onMouseEnter}
			onMouseUp={props.onMouseUp}
			outlineOffset={0}
			outline=".25px solid var(--chakra-colors-gray-200)"
			display="grid"
			gridTemplateRows="auto 1fr"
			overflow="auto"
			minH={{ base: '48', sm: 'auto' }}
			// If is between state selection put red bg
			backgroundColor={props.isDragging ? 'red.100' : 'white'}
		>
			<DateInfo day={props.day.dt} locale={props.locale} />

			<Box overflow="hidden" display="grid" gridTemplateRows={`repeat(8, 22px)`} gridTemplateColumns="1fr">
				{props.day.events.map((e: ICalendarEvent) => {
					return (
						<CalendarEvent
							timeZone={props.timeZone}
							key={e.id}
							day={props.day}
							event={e}
							locale={props.locale}
							onEventClick={props.onEventClick}
						/>
					);
				})}
			</Box>
		</Box>
	);
}
